export enum MARK_POINT {
    MAIN_START = 'mainStart',
    MAIN_END = 'mainEnd',
}

// 标记main.js开始时间
const markMainStart = function () {
    if (global && !global.jsRunMarkPoints?.[MARK_POINT.MAIN_START]) {
        global.jsRunMarkPoints = global.jsRunMarkPoints || {};
        global.jsRunMarkPoints[MARK_POINT.MAIN_START] = Date.now();
    }
};

// 标记main.js结束时间
const markMainEnd = function () {
    if (global && !global.jsRunMarkPoints?.[MARK_POINT.MAIN_END]) {
        global.jsRunMarkPoints = global.jsRunMarkPoints || {};
        global.jsRunMarkPoints[MARK_POINT.MAIN_END] = Date.now();
    }
};

// 立即执行，记录开始
markMainStart();

export { markMainEnd };
